var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 112C207.4 112 168 151.4 168 200C168 248.6 207.4 288 256 288C304.6 288 344 248.6 344 200C344 151.4 304.6 112 256 112ZM256 240C233.94 240 216 222.05 216 200C216 177.9 233.9 160 256 160C278.1 160 296 177.94 296 200C296 222.1 278.1 240 256 240ZM256 0C114.6 0 0 114.6 0 256C0 397.4 114.6 512 256 512C397.4 512 512 397.4 512 256C512 114.6 397.4 0 256 0ZM256 464C209.27 464 166.24 448.32 131.5 422.21C148.8 389 182.4 368 220.2 368H291.89C329.64 368 363.2 389.01 380.57 422.21C345.8 448.3 302.7 464 256 464ZM416.2 388.5C389.2 346.3 343.2 320 291.8 320H220.2C168.84 320 122.85 346.25 95.8 388.48C65.96 352.5 48 306.3 48 256C48 141.3 141.31 48 256 48C370.69 48 464 141.31 464 256C464 306.3 446 352.5 416.2 388.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.4a81fdec031012845720cb05bee54f90.svg";
export { ForwardRef as ReactComponent };